import Vue from 'vue'
import Vuex from 'vuex'
import cnode from './cnode'
import user from './user'
import nodegroup from './nodegroup'
import host from './host'
import ordertpl from './modules/ordertpl/ordertpl'
import createorder from './modules/createorder/createorder'
import submitorder from './modules/submitorder/submitorder'
import suborder from './modules/suborder/suborder'
import userinfo from './modules/userinfo/userinfo'
import flowconf from './modules/flowconf/flowconf'
import flowroleconf from './modules/flowroleconf/flowroleconf'
import meeting from './modules/meeting/meeting'
import monitor from './modules/monitor/monitor'
import slowquery from './modules/slowquery/slowquery'
import italen from './modules/italen/italen'
import cicd from './modules/cicd/cicd'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    cnode,
    user,
    nodegroup,
    host,
    ordertpl,
    createorder,
    submitorder,
    suborder,
    userinfo,
    flowconf,
    flowroleconf,
    meeting,
    monitor,
    slowquery,
    italen,
    cicd,
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js